import { createFileRoute } from '@tanstack/react-router'
import { FlightDataUploadPage } from 'pages/flightDataUpload/FlightDataUploadPage'
import { z } from 'zod'

const flightDataSearchSchema = z.object({
  step: z.enum(['component', 'config', 'upload']).optional(),
  asset: z.string().optional(),
  component: z.string().optional(),
  flightSet: z.enum(['day-rgb', 'day-ir', 'night-ir']).optional(),
  weather: z.string().optional(),
})

export const Route = createFileRoute('/flightDataUpload/$siteID')({
  component: RouteComponent,
  validateSearch: flightDataSearchSchema,
  staticData: {
    title: 'Flight Data Upload',
    layout: {
      showSidebar: false,
      enableScrolling: false,
    },
  },
})

function RouteComponent() {
  const { siteID } = Route.useParams()
  const search = Route.useSearch()

  return <FlightDataUploadPage siteID={siteID} searchParams={search} />
}
